// extracted by mini-css-extract-plugin
export default {"label":"Input_label__IRJC0","input":"Input_input__MUPZV","select":"Input_select__0COys"};